// The whole code is copied from VPC.

import { Tooltip, TooltipProps } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../gen-src/Localize';
import { imgPath } from '../../../common/utils/ImgUrl';

const INFO_ICON = 'data_prep_info.svg';
const ICON_PATH = imgPath(INFO_ICON);
const tooltipProps: TooltipProps = {
  // eslint-disable-next-line react/display-name
  getContent: () => <span>{Messages.encryptionTooltip()}</span>,
};

export const EncryptionTooltip = (): JSX.Element => {
  /* eslint-disable jsx-a11y/alt-text */
  return (
    <Tooltip {...tooltipProps}>
      <img style={{ minHeight: 15, position: 'relative', top: 3, left: 7 }} src={ICON_PATH} alt={Messages.More_info()} />
    </Tooltip>
  );
};
